// AccountPage.js
import React, { useState } from "react";
import { Flex, Box, Text } from "@chakra-ui/react";
import Translate from "../../components/LanguageTranslation/Translate";
import AccountSidebar from "./AccountSidebar";
import AccountSettings from "./AccountSettings"; // main profile form
import NotificationsSettings from "./NotificationsSettings";
export default function UserAccount() {
  const [active, setActive] = useState("Account"); // default tab

  // map label → component
  const panels = {
    Account: <AccountSettings />,
    // Privacy: <PrivacySettings />,
    Notification: <NotificationsSettings />,
    // ReportProblem: <ReportProblem />,
  };

  return (
    <>
      <Box
        p={4}
        pt={2}
        pb={2}
        borderBottom="1px"
        borderColor="gray.200"
        maxH="8vh"
      >
        <Text fontSize="lg" fontWeight="bold" color="blackAlpha.800" mt={1} mb={1}>
          <Translate text="Account settings" />
        </Text>
      </Box>
      <Flex w="100%" h="92vh">
        {/* (Your global sidebar is rendered higher in the tree) */}

        <AccountSidebar active={active} onSelect={setActive} />

        {/* render the chosen panel */}
        <Flex flex="1" overflow="auto">
          {panels[active]}
        </Flex>
      </Flex>
    </>
  );
}
